import React from "react";
import { graphql } from "gatsby";
import { PageBuilderSharedSectionRefFragment } from "types/graphql-types";
import SanityBuilderToComponents from "components/PageBuilder/index";
import { BackgroundColor } from "types/componentBackground";
import { isPresent } from "../../utils/checks";

export type PageBuilderSharedSectionProps =
  PageBuilderSharedSectionRefFragment & {
    initialBackgroundColor: BackgroundColor;
  };

const PageBuilderSharedSectionRef: React.FC<
  React.PropsWithChildren<PageBuilderSharedSectionProps>
> = ({ section, ...props }) => {
  const existingSections = section?.sections?.filter(isPresent);
  if (!existingSections) return null;

  return (
    <SanityBuilderToComponents
      sections={existingSections}
      {...props}
    ></SanityBuilderToComponents>
  );
};

export default PageBuilderSharedSectionRef;

export const fragments = graphql`
  fragment PageBuilderSharedSectionRef on SanitySharedSectionRef {
    _key
    _type
    section {
      sections {
        ...PageBuilderSections
      }
    }
  }
`;
